<div class="row">
  <div class="col-sm-12 col-md-7 pl-0 {{ isMobileDevice ? 'pr-2' : '' }} pr-4">
    <form [formGroup]="editProperty" class="edit-property-form tabs-wrap pb-4 position-relative">
      <div class="pl-3 pr-0">
        <div class="{{ isMobileDevice ? '' : 'd-flex align-items-start' }}">
          <div class="project-dp position-relative rounded {{ isMobileDevice ? 'w-100 h-250' : 'mr-4' }}">
            <ng-container *ngIf="property_img?.length > 0; else localImg">
              <ng-container
                *ngIf="
                  property_img?.length > 0 && (property_img[property_img?.length - 1]?.thumbPath || property_img[property_img?.length - 1]?.file);
                  else noImages
                ">
                <img
                  src="{{ S3Path + (property_img[property_img?.length - 1]?.thumbPath || property_img[property_img?.length - 1]?.file) }}"
                  class="project-dp  {{ isMobileDevice ? 'w-100 h-250' : '' }}" />
              </ng-container>
              <ng-template #noImages>
                <div class="project-dp {{ isMobileDevice ? 'w-100 h-250' : '' }} d-flex align-items-center justify-content-center border rounded">
                  <img [src]="images?.image_404" alt="" class="w-70px" />
                </div>
              </ng-template>
            </ng-container>
            <ng-template #localImg>
              <div *ngIf="imagesLogo?.length > 0; else noImages">
                <img [src]="imagesLogo[imagesLogo.length - 1]?.file" class="project-dp {{ isMobileDevice ? 'w-100 h-250' : '' }}" />
              </div>
              <ng-template #noImages>
                <div class="project-dp {{ isMobileDevice ? 'w-100 h-250' : '' }} d-flex align-items-center justify-content-center border rounded">
                  <img [src]="images?.image_404" alt="" class="w-70px" />
                </div>
              </ng-template>
            </ng-template>
            <input type="file" #logoInput (change)="onLogoSelect($event)" [hidden]="1" accept=".svg,image/*" multiple="false" />
            <div class="img-overlay cursor-pointer" (click)="logoInput.click()">
              <i class="pi pi-pencil"></i>
            </div>
            <p class="{{ isMobileDevice ? 'top-250' : '' }} prop_id d-flex align-items-center text-center ml-2" *ngIf="selectedProperty?.id">
              Property ID: {{ selectedProperty?.id }}
            </p>
          </div>
          <div class="w-100 position-relative" style="height: 197px">
            <div class="row {{ isMobileDevice ? 'mt-3' : '' }}">
              <div class="col-sm-11 {{ isMobileDevice ? '' : 'pr-0' }}">
                <div class="col p-0 position-relative">
                  <ng-container *ngIf="lmService.property_show_div == 'add_property'; else edited_property">
                    <div class="position-relative mt-1 top-search" *ngIf="isAvailableTrue">
                      <input
                        type="text"
                        class="_input-icon"
                        formControlName="property_address"
                        [ngClass]="{ invalidField: submitted && editProperty.controls['property_address'].invalid }"
                        placeholder="Search"
                        (input)="filterPropertyListing('exist')"
                        #propertyInput />
                      <i class="pi pi-search _search-icon bg-none"></i>
                      <i class="fa fa-times _cross-icon" *ngIf="editProperty.controls['property_address'].value" (click)="emptySearch()"></i>
                    </div>
                    <div *ngIf="isSearchTrue" class="listing-search-box">
                      <div *ngIf="filterProperty?.length > 0">
                        <p class="search-heading d-flex align-items-center">Properties</p>
                        <div class="loop-item">
                          <div *ngFor="let item of filterProperty">
                            <div class="item-display" (click)="selectFilterItem(item)">
                              <div *ngIf="item.property_images?.length > 0">
                                <img src="{{ S3Path + item.property_images[0]?.thumbPath }}" class="yes-images" />
                              </div>
                              <div *ngIf="item.property_images?.length <= 0">
                                <img [src]="common_images?.image_not_found" class="no-list-images" />
                              </div>
                              <div class="ml-2 w-100">
                                <div class="d-flex align-items-center justify-content-between postion-relative">
                                  <p class="_fw-600">{{ item.property_address.replace('Australia', '') }}</p>
                                </div>
                                <div class="mt-2 f-12">Type: {{ item.type }}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="editProperty.controls['property_address'].value && !filterProperty?.length && !isAvailableTrue">
                      <input
                        class="_input-icon 23"
                        placeholder="Search Address"
                        [ngClass]="{ invalidField: submitted && editProperty.controls['property_address'].invalid }"
                        google-places-autocomplete
                        [options]="options"
                        (onAddressChange)="handleAddressChange($event)"
                        (input)="filterPropertyListing('google')"
                        #addressInput
                        formControlName="property_address"
                        autocomplete="off"
                        (keydown.enter)="$event.preventDefault(); addressInput.blur()" />
                      <i class="pi pi-search _search-icon bg-none"></i>
                      <small class="text-danger d-block mt-1" *ngIf="editProperty.controls['property_address'].value && !isAddressValid">
                        Property address not found on Google Api, Please contact Remmi support.
                      </small>
                    </ng-container>
                  </ng-container>
                  <ng-template #edited_property>
                    <input
                      class="_input-icon 22"
                      placeholder="Search Address"
                      [ngClass]="{
                        '_input-error': editProperty.controls['property_address'].hasError('required') && submitted,
                      }"
                      google-places-autocomplete
                      [options]="options"
                      (onAddressChange)="handleAddressChange($event)"
                      #addressInput
                      formControlName="property_address"
                      autocomplete="off"
                      [class.disabled]="disablePropertyAddress"
                      (keydown.enter)="$event.preventDefault(); addressInput.blur()" />
                    <i class="pi pi-search _search-icon bg-none"></i>
                  </ng-template>
                </div>
              </div>
              <div class="col-sm-1 pl-0" *ngIf="!isMobileDevice && !filterProperty?.length">
                <button
                  id="toggle-overlay"
                  class="_addNew ml-2 mt-0"
                  (click)="openAddressOverlayPanel($event)"
                  [class.disabled]="disablePropertyAddress">
                  <img [src]="common_images?.pencil_icon" class="pencil-cross" width="12" />
                </button>
              </div>
              <div class="col-sm-11 mt-2 {{ isMobileDevice ? '' : 'pr-0' }}">
                <ng-select
                  class="primary-tag"
                  formControlName="type"
                  [items]="listingService.listingPropertyOption.property_Types"
                  bindLabel="tag_name"
                  bindValue="tag_name"
                  [searchable]="true"
                  [clearable]="false"
                  placeholder="Property Type"
                  [ngClass]="{ '_input-error': editProperty.controls['type'].hasError('required') && submitted }"
                  class="_select">
                  <ng-template ng-option-tmp let-item="item">
                    <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                  </ng-template>
                </ng-select>
              </div>
              <div class="position-relative">
                <p-overlayPanel #ops [style]="{ width: '500px' }" [dismissable]="true" [showCloseIcon]="true">
                  <ng-template pTemplate>
                    <div class="row">
                      <div class="col-lg-12 mb-4 d-flex align-items-center justify-content-between">
                        <h4 class="f-12 _fw-600">Property Address</h4>
                        <button class="_primary-btn" (click)="updateAddress(); ops.hide($event)">Save</button>
                      </div>
                      <div class="col-xl-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Building Name</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['building_name'].hasError('required') }"
                            class="_input"
                            formControlName="building_name"
                            placeholder="" />
                        </div>
                      </div>
                      <div class="col-lg-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Unit No</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['unit_no'].hasError('required') }"
                            class="_input"
                            formControlName="unit_no" />
                        </div>
                      </div>
                      <div class="col-lg-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Street No</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['street_no'].hasError('required') }"
                            class="_input"
                            formControlName="street_no" />
                        </div>
                      </div>
                      <div class="col-xl-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Street Name</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['street_name'].hasError('required') }"
                            class="_input"
                            formControlName="street_name" />
                        </div>
                      </div>
                      <div class="col-xl-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Suburb</p>
                          <div class="auto-complete-custom">
                            <p-autoComplete
                              formControlName="suburb"
                              [virtualScroll]="true"
                              [bufferAmount]="10"
                              [suggestions]="filteredItems"
                              [ngClass]="{ '_input-error': editProperty.controls['suburb'].hasError('required') }"
                              [itemSize]="34"
                              (completeMethod)="filterItems($event)"
                              field="suburb">
                            </p-autoComplete>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">State</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['state'].hasError('required') }"
                            class="_input"
                            formControlName="state" />
                        </div>
                      </div>
                      <div class="col-lg-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Post Code</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['post_code'].hasError('required') }"
                            class="_input"
                            formControlName="post_code" />
                        </div>
                      </div>
                      <div class="col-xl-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Country</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['country'].hasError('required') }"
                            class="_input"
                            formControlName="country" />
                        </div>
                      </div>
                      <div class="col-lg-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Latitude</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['latitude'].hasError('required') }"
                            class="_input"
                            formControlName="latitude" />
                        </div>
                      </div>
                      <div class="col-xl-6 mb-2">
                        <div class="form-group">
                          <p class="f-12 mb-2">Longitude</p>
                          <input
                            type="text"
                            [ngClass]="{ '_input-error': editProperty.controls['longitude'].hasError('required') }"
                            class="_input"
                            formControlName="longitude" />
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </p-overlayPanel>
              </div>
            </div>
            <div class="prod-btn">
              <ng-container *ngxPermissionsOnly="['allproperties.manage', 'allproperties.add']">
                <div *ngIf="lmService.property_show_div == 'add_property'">
                  <button
                    class="_outline-btn mr-2"
                    [class.disabled]="disableAddListing"
                    (click)="openRightModal(null, 'add_listing_from_property')"
                    *ngIf="!isMobileDevice">
                    <i class="pi pi-plus f-12 mr-1"></i>
                    Add Listing
                  </button>
                  <button class="_outline-btn mr-2" (click)="CreateProperty('onlyCreate')" [class.disabled]="submitDisable">Save</button>
                  <button class="_primary-btn" (click)="CreateProperty('create')" [class.disabled]="submitDisable">Save & Close</button>
                </div>
              </ng-container>
              <ng-container *ngIf="AuthUser?.role?.toLowerCase() == 'sales agent' && selectedProperty?.agent == AuthUser?._id; else elseEditPart">
                <div *ngxPermissionsOnly="['allproperties.manage', 'allproperties.add']">
                  <div *ngIf="lmService.property_show_div == 'edit_property'">
                    <button
                      class="_outline-btn mr-2"
                      [class.disabled]="disableAddListing"
                      (click)="openRightModal(null, 'add_listing_from_property')"
                      *ngIf="!isMobileDevice">
                      <i class="pi pi-plus f-12 mr-1"></i>
                      Add Listing
                    </button>
                    <button class="_outline-btn mr-2" (click)="updateProperty('onlyUpdate')" [class.disabled]="submitDisable">Save</button>
                    <button class="_primary-btn" (click)="updateProperty('update')">Save & Close</button>
                  </div>
                </div>
              </ng-container>
              <ng-template #elseEditPart>
                <div *ngxPermissionsOnly="['allproperties.manage', 'allproperties.edit']">
                  <div *ngIf="lmService.property_show_div == 'edit_property'">
                    <button
                      class="_outline-btn mr-2"
                      [class.disabled]="disableAddListing"
                      (click)="openRightModal(null, 'add_listing_from_property')"
                      *ngIf="!isMobileDevice">
                      <i class="pi pi-plus f-12 mr-1"></i>
                      Add Listing
                    </button>
                    <button class="_outline-btn mr-2" (click)="updateProperty('onlyUpdate')" [class.disabled]="submitDisable">Save</button>
                    <button class="_primary-btn" (click)="updateProperty('update')" [class.disabled]="submitDisable">Save & Close</button>
                  </div>
                </div>
              </ng-template>
              <p-dialog
                header="Sales Transaction"
                [showHeader]="true"
                [(visible)]="sale_transaction"
                [draggable]="false"
                [style]="{ width: '300px' }"
                [modal]="true"
                [baseZIndex]="100000">
                <div class="p-modal-body p-project-detail-body prop-action-meta">
                  <div class="col-sm-14 text-left mt-3 mb-4">
                    <p class="h6 font-weight-bold mb-0">Do you want to create a Sales Transaction?</p>
                  </div>
                  <div class="text-right p-modal-footer">
                    <button (click)="this.sale_transaction = false" class="_cancel-btn mr-2">No</button>
                    <button (click)="this.sale_transaction = false; this.manualGenerateHistory = true" class="_primary-btn">Yes</button>
                  </div>
                </div>
              </p-dialog>
            </div>
          </div>
        </div>
        <div class="pb-2">
          <p class="form-error font-weight-bold cursor-pointer" *ngIf="numOfNotValidFields > 0" (click)="notDisplayRequiredMessage = false">
            You have {{ numOfNotValidFields }} notifications. Select to view.
          </p>
          <div class="error-message" [ngClass]="{ 'd-none': notDisplayRequiredMessage }">
            <ul>
              <li class="pb-1 cursor-pointer" *ngFor="let message of requiredErrorMessages" (click)="ActivateTabIndexByError(message.field)">
                {{ message?.message | capitalizephrase }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="pl-3 pr-0 {{ isMobileDevice ? 'mt-2' : 'mt-5' }}">
        <ng-container *ngIf="isMobileDevice; else noMobile">
          <div class="mobile-tab mb-3">
            <div class="w-100 d-flex align-items-center justify-content-between cursor-pointer" (click)="showMenu = !showMenu">
              <p>{{ selectedItem ? selectedItem?.name : 'Property Detail' }}</p>
              <i class="pi pi-chevron-down f-14 mobile-tab-icon cursor-pointer"></i>
            </div>
            <ng-container *ngIf="showMenu">
              <ul class="mobile-tab-menu">
                <li *ngFor="let item of menu_items; let i = index" (click)="selectItem(item)">
                  {{ item.name }}
                </li>
              </ul>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #noMobile>
          <div class="d-flex align-items-center primary-tabs b-b-tabs">
            <ul class="nav nav-pills mb-2 tools-tab-nav w-100 align-items-end" id="pills-tab" role="tablist">
              <li class="nav-item cursor-pointer" role="presentation" (click)="activeIndex = 0; isDocuments = false; isAppraisal = false">
                <a
                  class="{{ activeIndex === 0 ? 'active' : '' }} pl-0"
                  id="pills-PropertyDetails-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#PropertyDetails"
                  role="tab"
                  aria-controls="PropertyDetails"
                  aria-selected="true">
                  Property Details
                </a>
              </li>
              <li
                class="nav-item cursor-pointer"
                role="presentation"
                (click)="isAppraisal = false; isDocuments = true; activeIndex = 1; shouldResetDocuments = true; resetDocuments()">
                <a
                  class="{{ activeIndex === 1 ? 'active' : '' }}"
                  id="pills-Documents-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#Documents"
                  role="tab"
                  aria-controls="Documents"
                  aria-selected="false"
                  >Documents</a
                >
              </li>
              <li
                *ngFlag="'my_task'"
                class="nav-item cursor-pointer"
                role="presentation"
                (click)="activeIndex = 2; this.getTasks(); isDocuments = false; isAppraisal = false">
                <a
                  class="{{ activeIndex === 2 ? 'active' : '' }}"
                  id="pills-Tasks-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#Tasks"
                  role="tab"
                  aria-controls="Tasks"
                  aria-selected="false">
                  Tasks
                  <p class="ml-2 a-head-badge" *ngIf="fullList?.length > 0">{{ fullList?.length }}</p>
                </a>
              </li>
              <li
                *ngFlag="'appraisals'"
                class="nav-item cursor-pointer"
                role="presentation"
                (click)="
                  activeIndex = 3; isDocuments = false; isAppraisal = true; getAppraisal(); this.lmService.getShortContacts(); this.getAgents()
                ">
                <a
                  class="{{ activeIndex === 3 ? 'active' : '' }}"
                  id="pills-Appraisals-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#Appraisals"
                  role="tab"
                  aria-controls="Appraisals"
                  aria-selected="false">
                  Appraisals
                  <p class="ml-2 a-head-badge" *ngIf="appraisalList?.length > 0">{{ appraisalList?.length }}</p>
                </a>
              </li>
              <li
                class="nav-item cursor-pointer"
                role="presentation"
                (click)="activeIndex = 4; isDocuments = false; isAppraisal = false"
                *ngFlag="'notes'">
                <a
                  class="{{ activeIndex === 4 ? 'active' : '' }}"
                  id="pills-property_notes-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#property_notes"
                  role="tab"
                  aria-controls="property_notes"
                  aria-selected="false">
                  Notes
                </a>
              </li>
            </ul>
          </div>
        </ng-template>
        <div class="tab-content" id="pills-tabContent">
          <div
            id="PropertyDetails"
            role="tabpanel"
            aria-labelledby="pills-PropertyDetails-tab"
            tabindex="0"
            class="tab-pane fade {{ activeIndex === 0 && 'show active' }}">
            <div class="my-2">
              <div class="overlay-background row mb-2 mx-0 {{ isMobileDevice ? 'p-2' : '' }}">
                <div class="col-sm-2 pl-0 {{ isMobileDevice && 'mt-2' }}">
                  <p class="f-12 mb-1">Bedrooms</p>
                  <input
                    type="number"
                    class="_input"
                    formControlName="beds"
                    [ngClass]="{ '_input-error': editProperty.controls['beds'].hasError('required') }"
                    min="0" />
                </div>
                <div class="col-sm-2 pl-0 {{ isMobileDevice && 'mt-2' }}">
                  <p class="f-12 mb-1">Bathrooms</p>
                  <input
                    type="number"
                    class="_input"
                    formControlName="baths"
                    [ngClass]="{ '_input-error': editProperty.controls['baths'].hasError('required') }"
                    min="0" />
                </div>
                <div class="col-sm-2 pl-0 {{ isMobileDevice && 'mt-2' }}">
                  <p class="f-12 mb-1">Ensuite</p>
                  <input
                    type="number"
                    class="_input"
                    formControlName="ensuite"
                    [ngClass]="{ '_input-error': editProperty.controls['ensuite'].hasError('required') }"
                    min="0" />
                </div>
                <div class="col-sm-2 pl-0 {{ isMobileDevice && 'mt-2' }}">
                  <p class="f-12 mb-1">Living Areas</p>
                  <input
                    type="number"
                    min="0"
                    class="_input"
                    formControlName="living_areas"
                    [ngClass]="{ '_input-error': editProperty.controls['living_areas'].hasError('required') }" />
                </div>
                <div class="col-sm-2 pl-0 {{ isMobileDevice && 'mt-2' }}">
                  <p class="f-12 mb-1">Study</p>
                  <input
                    type="number"
                    class="_input"
                    formControlName="study"
                    [ngClass]="{ '_input-error': editProperty.controls['study'].hasError('required') }"
                    min="0" />
                </div>
                <div class="col-sm-2 pl-0 {{ isMobileDevice && 'mt-2' }}">
                  <p class="f-12 mb-1">Pool</p>
                  <input
                    type="number"
                    formControlName="pools"
                    class="_input"
                    [ngClass]="{ '_input-error': editProperty.controls['pools'].hasError('required') }"
                    min="0" />
                </div>
              </div>
              <div class="overlay-background row mb-2 mx-0 {{ isMobileDevice ? 'p-2' : '' }}">
                <p class="f-12 p-0 _fw-600 mb-2">Car Spaces</p>
                <div class="row {{ isMobileDevice ? 'px-2' : '' }}" style="margin-left: -12px">
                  <div class="col-sm-3 p-0">
                    <p class="f-12 mb-1">Garage</p>
                    <input
                      type="number"
                      class="_input"
                      formControlName="garage"
                      [ngClass]="{ '_input-error': editProperty.controls['garage'].hasError('required') }"
                      min="0" />
                  </div>
                  <div class="col-sm-3 {{ isMobileDevice ? 'mt-2' : 'ml-2 resp1' }}  p-0">
                    <p class="f-12 mb-1">Carport</p>
                    <input
                      type="number"
                      class="_input"
                      formControlName="car_port"
                      [ngClass]="{ '_input-error': editProperty.controls['car_port'].hasError('required') }"
                      min="0" />
                  </div>
                  <div class="col-sm-3 {{ isMobileDevice ? 'mt-2' : 'ml-2 resp1' }}  p-0">
                    <p class="f-12 mb-1">Open Spaces</p>
                    <input
                      type="number"
                      class="_input"
                      formControlName="open_spaces"
                      [ngClass]="{ '_input-error': editProperty.controls['open_spaces'].hasError('required') }"
                      min="0" />
                  </div>
                </div>
              </div>
              <div class="overlay-background row mb-2 mx-0 {{ isMobileDevice ? 'p-2' : '' }}">
                <div class="col-sm-2 mb-0 p-0">
                  <p class="f-12 mb-1">Land Area</p>
                  <div>
                    <input
                      type="number"
                      [ngClass]="{ '_input-error': editProperty.controls['land_area'].hasError('required') }"
                      (keypress)="allowOnlyNumberAndDecimal($event)"
                      class="_input h-37"
                      formControlName="land_area" />
                  </div>
                </div>
                <div class="col-sm-2 p-0 {{ isMobileDevice ? 'mt-2' : 'ml-2 building-area' }}">
                  <p class="f-12 mb-1"></p>
                  <div>
                    <ng-select
                      formControlName="land_area_type"
                      [items]="listingService.listingPropertyOption.land_building_area_type"
                      bindLabel="tag_name"
                      [ngClass]="{ '_input-error': editProperty.controls['land_area_type'].hasError('required') }"
                      bindValue="tag_name"
                      [searchable]="true"
                      class="_select">
                      <ng-template ng-option-tmp let-item="item">
                        <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                      </ng-template>
                    </ng-select>
                    <span class="dummy-text" *ngIf="editProperty.controls['land_area_type'].hasError('required')">
                      <p class="form-error">Land Area Type is required<br /></p>
                    </span>
                  </div>
                </div>
                <div class="col-sm-2  {{ isMobileDevice ? 'mt-2' : 'ml-2 mb-0 resp1' }} p-0 ">
                  <p class="f-12 mb-1">Building Area</p>
                  <div>
                    <input
                      type="number"
                      [ngClass]="{ '_input-error': editProperty.controls['building_area'].hasError('required') }"
                      (keypress)="allowOnlyNumberAndDecimal($event)"
                      class="_input h-37"
                      formControlName="building_area" />
                  </div>
                </div>
                <div class="col-sm-2 {{ isMobileDevice ? 'mt-2' : 'ml-2 building-area' }} p-0">
                  <p class="f-12 mb-1"></p>
                  <div>
                    <ng-select
                      formControlName="building_area_type"
                      [items]="listingService.listingPropertyOption.land_building_area_type"
                      bindLabel="tag_name"
                      [ngClass]="{ '_input-error': editProperty.controls['building_area_type'].hasError('required') }"
                      bindValue="tag_name"
                      [searchable]="true"
                      class="_select">
                      <ng-template ng-option-tmp let-item="item">
                        <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="col-sm-2 {{ isMobileDevice ? 'mt-2' : 'ml-2 mb-0 resp1' }} p-0">
                  <p class="f-12 mb-1">Year Built</p>
                  <div>
                    <input
                      type="text"
                      [ngClass]="{ '_input-error': editProperty.controls['year_built'].hasError('required') }"
                      class="_input h-37"
                      formControlName="year_built" />
                  </div>
                </div>
              </div>
              <div class="overlay-background row mb-2 mx-0 {{ isMobileDevice ? 'p-2' : '' }}">
                <div class="form-group mb-0 px-0">
                  <p class="f-12 mb-2">Brief Overview</p>
                  <div class="_paragraph">
                    <ckeditor
                      formControlName="description_garax"
                      [editor]="Editor"
                      (ready)="onReadyDes($event)"
                      [ngClass]="{
                        '_input-error': editProperty.controls['isHideAddress'].hasError('required') && submitted,
                      }">
                    </ckeditor>
                  </div>
                </div>
              </div>
              <div class="row mb-2 pl-0 pr-0 ml-0">
                <app-collapse-box [headingClassName]="'f-14'" class="pl-0" [heading]="'Features'" [border]="'0'">
                  <div class="row">
                    <div class="col-lg-6 col-xl-12 mb-3 {{ isMobileDevice ? 'px-0' : '' }}">
                      <div class="features-mutiple-list">
                        <p class="f-12 mb-2">Features</p>
                        <div class="feature-multi-select">
                          <re-multiSelect
                            [options]="listingService.listingPropertyOption.property_features"
                            formControlName="features"
                            optionLabel="feature_name"
                            optionValue="feature_name"
                            [truncate]="60"
                            placeholder="Please Select"></re-multiSelect>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-12 mb-2  {{ isMobileDevice ? 'px-0' : '' }}">
                      <p class="_fw-600">Other</p>
                    </div>
                    <div class="col-lg-6 mb-2 {{ isMobileDevice ? 'px-0' : '' }}">
                      <p class="f-12 mb-2">Exterior</p>
                      <input
                        type="text"
                        [ngClass]="{ '_input-error': editProperty.controls['exterior'].hasError('required') }"
                        class="_input"
                        formControlName="exterior" />
                    </div>
                    <div class="col-lg-6 mb-2 {{ isMobileDevice ? 'px-0' : '' }}">
                      <p class="f-12 mb-2">Roofing</p>
                      <input
                        type="text"
                        [ngClass]="{ '_input-error': editProperty.controls['roofing'].hasError('required') }"
                        class="_input"
                        formControlName="roofing" />
                    </div>
                    <div class="col-lg-6 mb-0 {{ isMobileDevice ? 'px-0' : '' }}">
                      <p class="f-12 mb-2">Energy Rating</p>
                      <input
                        type="text"
                        [ngClass]="{ '_input-error': editProperty.controls['energy_rating'].hasError('required') }"
                        class="_input"
                        formControlName="energy_rating" />
                    </div>
                    <div class="col-lg-6 mb-0 {{ isMobileDevice ? 'px-0' : '' }}">
                      <p class="f-12 mb-2">Views</p>
                      <input
                        type="text"
                        [ngClass]="{ '_input-error': editProperty.controls['views'].hasError('required') }"
                        class="_input"
                        formControlName="views" />
                    </div>
                  </div>
                </app-collapse-box>
              </div>
            </div>
          </div>
          <div
            id="Documents"
            role="tabpanel"
            aria-labelledby="pills-Documents-tab"
            tabindex="0"
            class="tab-pane fade {{ activeIndex === 1 && 'show active' }}">
            <ng-container *ngIf="isDocuments">
              <div class="sticky-sidebar">
                <div class="site-card p-2 w-100 lib-content px-3 library br-16" [ngClass]="{ 'mb-12': property_id?.length > 0 }">
                  <app-library-view-mode
                    *ngIf="(lmService.property_show_div == 'edit_property' || insertedPropertyId) && !shouldResetDocuments"
                    [noShowListingButton]="true"
                    category="useroffice"
                    [propertyId]="property_id || insertedPropertyId"
                    defaultopen="{{ editProperty.controls['property_address'].value }}"
                    innerdefault=""
                    (LibraryOutputData)="GetLibraryData($event)"
                    [hidePropertyLibrary]="true">
                  </app-library-view-mode>
                </div>
              </div>
            </ng-container>
          </div>
          <div
            id="Tasks"
            role="tabpanel"
            aria-labelledby="pills-Tasks-tab"
            tabindex="0"
            class="tab-pane fade {{ activeIndex === 2 && 'show active' }}">
            <div class="resp2">
              <div class="mt-2 mb-3 text-right" *ngIf="!isMobileDevice">
                <button class="_outline-btn" (click)="addNewTask(null, true)" *ngxPermissionsOnly="['task.create']">
                  <i class="pi pi-plus mr-2 f-10"></i>New Task
                </button>
              </div>
              <div class="position-relative">
                <div class="scrol_" (scroll)="onTaskScroll($event)" #taskScrollableElement>
                  <i class="pi pi-arrow-up" (click)="scrollTaskToTop()" *ngIf="taskScrollTop > 50"></i>
                  <p-table styleClass="pagination-dropdown" scrollWidth="100%" dataKey="_id" [value]="fullList" [rows]="taskRows" [rowHover]="false">
                    <ng-template pTemplate="colgroup">
                      <colgroup *ngIf="fullList?.length > 0">
                        <col class="w-30px" />
                        <col class="w-150px" />
                        <col class="w-80px" />
                        <col class="w-80px" />
                        <col class="w-80px" />
                        <col class="w-80px" />
                        <col class="w-80px" />
                      </colgroup>
                      <colgroup *ngIf="fullList?.length === 0">
                        <col />
                        <col />
                        <col />
                        <col />
                        <col />
                        <col />
                      </colgroup>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th *ngIf="fullList?.length > 0"></th>
                        <th pSortableColumn="title" class="f-12">
                          <div class="d-flex align-items-center">Title<p-sortIcon field="title" class="ml-2"></p-sortIcon></div>
                        </th>
                        <th pSortableColumn="jobType.data.name" class="f-12">
                          <div class="d-flex align-items-center">Task Type<p-sortIcon field="jobType.data.name" class="ml-2"></p-sortIcon></div>
                        </th>
                        <th pSortableColumn="taskStatus.data.name" class="f-12">
                          <div class="d-flex align-items-center">Task Status<p-sortIcon field="taskStatus.data.name" class="ml-2"></p-sortIcon></div>
                        </th>
                        <th pSortableColumn="taskStatus.data.assign" class="f-12">
                          <div class="d-flex align-items-center">Assignee <p-sortIcon field="taskStatus.data.assign" class="ml-2"></p-sortIcon></div>
                        </th>
                        <th pSortableColumn="start_date" class="f-12">
                          <div class="d-flex align-items-center">Start Date<p-sortIcon field="start_date" class="ml-2"></p-sortIcon></div>
                        </th>
                        <th pSortableColumn="due_date" class="f-12">
                          <div class="d-flex align-items-center">Due Date<p-sortIcon field="due_date" class="ml-2"></p-sortIcon></div>
                        </th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-task>
                      <tr style="overflow: visible">
                        <td>
                          <i class="pi pi-exclamation-triangle" *ngIf="task?.is_exclamation"></i>
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="addNewTask(task, false)">{{ task?.title }}</td>
                        <td class="cursor-pointer text-captilize" (click)="addNewTask(task, false)">
                          {{ task?.jobType.data.name }}
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="addNewTask(task, false)">
                          {{ task?.taskStatus.data.name }}
                        </td>
                        <td class="cursor-pointer text-captilize overflow-hidden" (click)="addNewTask(task, false)">
                          <ng-container *ngFor="let f of task?.assignToUsers?.data">
                            <p-badge class="mr-1 text-nowrap">{{ f['full_name'] }}</p-badge>
                          </ng-container>
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="addNewTask(task, false)">
                          {{ task?.start_date | date: 'dd/MM/yy' }}
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="addNewTask(task, false)">
                          {{ task?.due_date | date: 'dd/MM/yy' }}
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td colspan="7">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
              <div class="mt-5">
                <p *ngIf="fullList?.length > 0">
                  {{ 'Records: ' + fullList?.length }}
                </p>
              </div>
            </div>
          </div>
          <div
            id="Appraisals"
            role="tabpanel"
            aria-labelledby="pills-Appraisals-tab"
            tabindex="0"
            class="tab-pane fade {{ activeIndex === 3 && 'show active' }}">
            <div class="d-flex justify-content-end my-2">
              <ng-container *ngIf="createAppraisal">
                <div class="row" *ngIf="isUpdate == false">
                  <div>
                    <button class="_cancel-btn mr-1" (click)="cancelAppraisal(form)">Cancel</button>
                    <button class="_outline-btn mr-1" (click)="saveAppraisal('onlySave')">Save</button>
                    <button class="_primary-btn mr-1" (click)="saveAppraisal('save')">Save & Close</button>
                  </div>
                </div>
                <div class="row" *ngIf="isUpdate == true">
                  <div>
                    <button class="_cancel-btn mr-1" (click)="cancelAppraisal(form)">Cancel</button>
                    <button class="_outline-btn mr-1" (click)="updateAppraisal('onlySave')">Save</button>
                    <button class="_primary-btn mr-1" (click)="updateAppraisal('save')">Save & Close</button>
                  </div>
                </div>
              </ng-container>
              <div
                *ngIf="
                  (user_permission.includes('appraisal.manage') ||
                    user_permission.includes('appraisal.add') ||
                    user_role == 'administrators' ||
                    user_role == 'master admin') &&
                  !createAppraisal
                ">
                <ng-container *ngIf="isMobileDevice; else noMobApp">
                  <div class="d-flex align-items-center justify-content-between">
                    <p class="f-14 _fw-600">Appraisal</p>
                    <button class="_addNew {{ isMobileDevice ? 'f-12 h-auto p-2 w-auto' : 'position-change' }}" (click)="showAppraisal()">
                      <i class="pi pi-plus {{ isMobileDevice ? 'f-12' : '' }}"></i>
                    </button>
                  </div>
                </ng-container>
                <ng-template #noMobApp>
                  <button class="_outline-btn" (click)="showAppraisal()"><i class="pi pi-plus mr-2 f-10"></i>Appraisal</button>
                </ng-template>
              </div>
            </div>
            <div *ngIf="createAppraisal" class="overlay-background">
              <p class="f-12 font-weight-bold">New Appraisal</p>
              <form #form="ngForm">
                <div class="row mt-3">
                  <div class="col-sm-4">
                    <p class="f-12 mb-1">Agent/s</p>
                    <ng-select
                      [items]="originalAssigns"
                      [(ngModel)]="appraisal.agent"
                      [ngModelOptions]="{ standalone: true }"
                      [multiple]="true"
                      [searchable]="true"
                      bindLabel="full_name"
                      bindValue="_id"
                      placeholder="Select Agent">
                      <ng-template ng-label-tmp let-item="item">
                        <div class="d-flex align-items-center">
                          <i class="ng-value-icon pi pi-times-circle cursor-pointer" (click)="clear(item?._id, 'agent')"></i>
                          <p class="ng-value-label" (click)="openRightModal(item, 'staff')" tooltipPosition="top" [pTooltip]="item.full_name">
                            {{ item.full_name }}
                          </p>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-sm-4 width-100">
                    <p class="f-12 mb-1">Date of Appraisal</p>
                    <p-calendar
                      name="balanceDue"
                      [firstDayOfWeek]="1"
                      [(ngModel)]="appraisal.appraisal_Date"
                      [ngModelOptions]="{ standalone: true }"
                      dateFormat="dd/mm/yy"
                      class="_input"
                      placeholder="Appraisal Date"
                      (onSelect)="onDateSelect($event)"
                      [readonlyInput]="true">
                    </p-calendar>
                  </div>
                  <div class="col-sm-4">
                    <p class="f-12 mb-1">Appraisal Status</p>
                    <ng-select
                      [items]="listingService.listingPropertyOption.appraisal_Status"
                      [(ngModel)]="appraisal.appraisal_status"
                      [ngModelOptions]="{ standalone: true }"
                      [searchable]="true"
                      bindLabel="tag_name"
                      bindValue="tag_name"
                      placeholder="Select Appraisal Status"
                      class="_select">
                      <ng-template ng-option-tmp let-item="item">
                        <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                      </ng-template>
                    </ng-select>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-4">
                    <p class="f-12 mb-1">Owner</p>
                    <re-multiselect
                      [module]="'contacts'"
                      [truncate]="13"
                      [selected_ids]="appraisal.owner"
                      (onUpdate)="onUpdateMSelect($event, 'owner')"
                      (editRecord)="editRecord($event)"
                      [placeholder]="'Select Owner'"
                      (createNew)="openRightModal(null, 'add_contact')"
                      [isCreateNew]="true"
                      [isEmail]="true"
                      [style]="{ width: '100%' }">
                    </re-multiselect>
                  </div>
                  <div class="col-sm-4">
                    <p class="f-12 mb-1">Valuation Price Guide</p>
                    <input
                      type="number"
                      class="_input"
                      placeholder="Valuation price guide"
                      [(ngModel)]="appraisal.price_guide"
                      [ngModelOptions]="{ standalone: true }" />
                  </div>
                  <div class="col-sm-4">
                    <div>
                      <p class="f-12 mb-1">Lead Source</p>
                      <ng-select
                        [items]="listingService.listingPropertyOption.lead_source"
                        [(ngModel)]="appraisal.lead_source"
                        [ngModelOptions]="{ standalone: true }"
                        [searchable]="true"
                        bindLabel="tag_name"
                        bindValue="tag_name"
                        placeholder="Select Lead Source"
                        class="_select">
                        <ng-template ng-option-tmp let-item="item">
                          <div tooltipPosition="top" [pTooltip]="item.tag_name">{{ item.tag_name }}</div>
                        </ng-template>
                      </ng-select>
                    </div>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="mt-2">
                    <p class="f-12 mb-1">Notes</p>
                    <textarea name="note" spellcheck="true" class="_textArea" [(ngModel)]="appraisal.notes" [ngModelOptions]="{ standalone: true }">
                    </textarea>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-sm-12">
                    <div>
                      <p class="f-12 mb-1">Document</p>
                      <small *ngIf="insertedAppraisalId == '' || insertedAppraisalId == null"
                        >Please save your appraisal before uploading any files</small
                      >
                      <div class="sticky-sidebar" *ngIf="isAppraisal && insertedAppraisalId != '' && insertedAppraisalId != null">
                        <div class="site-card p-4 w-100 lib-content px-3 library br-16" [ngClass]="{ 'mb-5': property_id?.length > 0 }">
                          <app-library-view-mode
                            *ngIf="lmService.property_show_div == 'edit_property' || insertedPropertyId"
                            category="useroffice"
                            [propertyId]="property_id || insertedPropertyId"
                            defaultopen="property:"
                            innerdefault="appraisals"
                            [hidePropertyLibrary]="true"
                            [appraisalsFolderId]="insertedAppraisalId"
                            (LibraryOutputData)="GetLibraryData($event)">
                          </app-library-view-mode>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div class="row">
              <div class="col-sm-12 position-relative">
                <div class="scrol_" (scroll)="onAppraisalScroll($event)" #appraisalScrollableElement>
                  <i class="pi pi-arrow-up" (click)="scrollAppraisalToTop()" *ngIf="appraisalScrollTop > 50"></i>
                  <p-table
                    styleClass="pagination-dropdown"
                    scrollWidth="100%"
                    dataKey="_id"
                    [value]="appraisalList"
                    [paginator]="false"
                    [rows]="appraisalRows"
                    [rowHover]="false">
                    <ng-template pTemplate="header">
                      <tr class="no-wrap">
                        <th>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Owner</p>
                            <p-sortIcon [field]="'full_name'" [pSortableColumn]="'full_name'" class="pl-2 cursor-pointer"></p-sortIcon>
                          </div>
                        </th>
                        <th>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Appraisal Date</p>
                            <p-sortIcon [field]="'appraisal_Date'" [pSortableColumn]="'appraisal_Date'" class="pl-2 cursor-pointer"></p-sortIcon>
                          </div>
                        </th>
                        <th>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Appraisal Status</p>
                            <p-sortIcon [field]="'appraisal_status'" [pSortableColumn]="'appraisal_status'" class="pl-2 cursor-pointer"></p-sortIcon>
                          </div>
                        </th>
                        <th>
                          <div class="d-flex align-items-center justify-content-between">
                            <p>Appraisal Agent</p>
                            <p-sortIcon [field]="'full_name'" [pSortableColumn]="'full_name'" class="pl-2 cursor-pointer"></p-sortIcon>
                          </div>
                        </th>
                        <th class="w-70px">Action</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-appraisal>
                      <tr>
                        <td class="cursor-pointer text-capitalize overflow-hidden" (click)="updateApp(appraisal)">
                          <ng-container *ngFor="let f of appraisal?.owner; let isLast = last">
                            <p [ngStyle]="{ color: disableAppraisalRows(appraisal) ? 'darkgrey' : '' }">{{ f?.full_name }}{{ isLast ? '' : ', ' }}</p>
                          </ng-container>
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="updateApp(appraisal)">
                          <p [ngStyle]="{ color: disableAppraisalRows(appraisal) ? 'darkgrey' : '' }">
                            {{ appraisal?.appraisal_Date | date: 'dd/MM/yy' }}
                          </p>
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="updateApp(appraisal)">
                          <p [ngStyle]="{ color: disableAppraisalRows(appraisal) ? 'darkgrey' : '' }">
                            {{ appraisal?.appraisal_status }}
                          </p>
                        </td>
                        <td class="cursor-pointer text-captilize" (click)="updateApp(appraisal)">
                          <ng-container *ngFor="let f of appraisal?.agent; let isLast = last">
                            <p [ngStyle]="{ color: disableAppraisalRows(appraisal) ? 'darkgrey' : '' }">{{ f?.full_name }}{{ isLast ? '' : ', ' }}</p>
                          </ng-container>
                        </td>
                        <td class="text-left w-30px">
                          <button
                            class="btn p-0"
                            *ngIf="
                              user_permission.includes('appraisal.manage') || user_role == 'administrators' || user_role == 'master admin';
                              else canDelete
                            ">
                            <img [src]="common_images?.delete_icon" alt="delete" width="16px" (click)="deleteAppraisal(appraisal._id, $event)" />
                          </button>
                          <ng-template #canDelete>
                            <button class="btn p-0" *ngIf="user_permission.includes('appraisal.delete') && appraisal.user_id == user_id">
                              <img [src]="common_images?.delete_icon" alt="delete" width="16px" (click)="deleteAppraisal(appraisal._id, $event)" />
                            </button>
                          </ng-template>
                        </td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                      <tr>
                        <td [attr.colspan]="5">No record found.</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
            </div>
          </div>
          <div
            id="property_notes"
            role="tabpanel"
            aria-labelledby="pills-property_notes-tab"
            tabindex="0"
            class="tab-pane fade {{ activeIndex === 4 && 'show active' }}">
            <div *ngIf="activeIndex === 4">
              <app-notes
                [moduleId]="
                  this.selectedProperty || {
                    _id: this.insertedPropertyId,
                    property_address: editProperty.controls['property_address'].value,
                  }
                "></app-notes>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-sm-12 col-md-5 property-details position-relative">
    <div class="process-setting" style="right: 40px !important" *ngIf="property_id && lmService?.showIcons">
      <img
        [src]="common_images?.delete_theme"
        alt="delete"
        *ngxPermissionsOnly="['allproperties.manage', 'allproperties.delete']"
        (click)="deleteThisProperty()"
        width="18px"
        pTooltip="Delete"
        tooltipPosition="left" />
    </div>
    <ng-container
      *ngIf="
        (user_role == 'administrators' ||
          user_role == 'master admin' ||
          user_role == 'operations manager' ||
          user_permission.includes('property_process.view')) &&
        lmService?.showIcons
      ">
      <img
        [src]="common_images?.automation_icon"
        [ngClass]="{ 'icon-red': no_process_run === true }"
        *ngFlag="'automation'"
        class="process-setting"
        pTooltip="Automation"
        tooltipPosition="left"
        (click)="GetPropertyWorkflowProcesses()" />
    </ng-container>
    <div class="mb-4 pb-4 position-relative">
      <ng-container *ngIf="isMobileDevice; else noHisMobile">
        <div class="mobile-tab mb-3">
          <div class="w-100 d-flex align-items-center justify-content-between cursor-pointer" (click)="showMenuHistory = !showMenuHistory">
            <p>{{ selectedItemHistory ? selectedItemHistory?.name : 'Listing History' }}</p>
            <i class="pi pi-chevron-down f-14 mobile-tab-icon cursor-pointer"></i>
          </div>
          <ng-container *ngIf="showMenuHistory">
            <ul class="mobile-tab-menu">
              <li *ngFor="let item of itemsHistory; let i = index" (click)="selectHistory(item, i)">
                {{ item.name }}
              </li>
            </ul>
          </ng-container>
        </div>
      </ng-container>
      <ng-template #noHisMobile>
        <div class="d-flex align-items-center primary-tabs b-b-tabs">
          <ul class="nav nav-pills tools-tab-nav w-100 align-items-end" id="pills-tab" role="tablist">
            <li class="nav-item cursor-pointer" role="presentation" (click)="activeIndexRight = 0">
              <a
                class="{{ activeIndexRight === 0 ? 'active' : '' }} pl-0"
                id="pills-ListingHistory-tab"
                data-bs-toggle="pill"
                data-bs-target="#ListingHistory"
                role="tab"
                aria-controls="ListingHistory"
                aria-selected="true"
                ><i class="pi pi-history f-14 mr-1"></i> Listing History</a
              >
            </li>
            <li class="nav-item cursor-pointer" role="presentation" (click)="activeIndexRight = 1; getHistoryList(this.selectedProperty)">
              <a
                class="{{ activeIndexRight === 1 ? 'active' : '' }}"
                id="pills-PropertyHistory-tab"
                data-bs-toggle="pill"
                data-bs-target="#PropertyHistory"
                role="tab"
                aria-controls="PropertyHistory"
                aria-selected="false"
                ><img [src]="common_images?.home" alt="home" width="16px" class="mr-1" /> Property History</a
              >
            </li>
          </ul>
        </div>
      </ng-template>
      <div class="tab-content" id="pills-tabContent">
        <div
          id="ListingHistory"
          role="tabpanel"
          aria-labelledby="pills-ListingHistory-tab"
          tabindex="0"
          class="tab-pane fade {{ activeIndexRight === 0 && 'show active' }}">
          <div class="my-3 viewAll">
            <button class="{{ isMobileDevice ? 'p-2' : '' }} _outline-btn" (click)="createManualTransaction(); this.lmService.getShortContacts(true)">
              <i class="pi pi-plus mr-2 f-10 primary-color"></i>
              Create Sales Transaction
            </button>
            <button class="preview-btn" *ngIf="listingPropertyHistory?.length && isLatestListing" (click)="listingHistoriesDialog?.show()">
              View Full History
            </button>
            <button class="preview-btn" *ngIf="getManualHistory?.length && isLatestManual" (click)="manualDetailDialog?.show()">
              View Full History
            </button>
          </div>
          <ng-container *ngIf="manualGenerateHistory">
            <div class="row">
              <div class="col-md-12 col-sm-12 width-100 owner">
                <label class="f-12 mb-1">Previous Owner</label>
                <re-multiselect
                  [module]="'contacts'"
                  [truncate]="13"
                  [selected_ids]="manualHistory.seller"
                  (onUpdate)="onUpdateMSelect($event, 'seller')"
                  (editRecord)="editRecord($event)"
                  [placeholder]="'Select Previous Owner'"
                  (createNew)="openRightModal(null, 'add_contact')"
                  [isCreateNew]="true"
                  [style]="{ width: '100%' }"
                  [truncate]="50"
                  [isEmail]="true">
                </re-multiselect>
              </div>
              <div class="col-md-12 col-sm-12 width-100 mt-2 owner">
                <label class="f-12 mb-1">Current Owner</label>
                <re-multiselect
                  [module]="'contacts'"
                  [truncate]="13"
                  [selected_ids]="manualHistory.buyer"
                  (onUpdate)="onUpdateMSelect($event, 'buyer')"
                  (editRecord)="editRecord($event)"
                  [placeholder]="'Select Current Owner'"
                  (createNew)="openRightModal(null, 'add_contact')"
                  [isCreateNew]="true"
                  [required_class]="manualHistory?.buyer?.length == 0 && errorMessage ? true : false"
                  [style]="{ width: '100%' }"
                  [truncate]="50"
                  [isEmail]="true">
                </re-multiselect>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 col-lg-6 col-sm-12 width-100 pr-0">
                <div class="form-group mb-2">
                  <p class="f-12 mb-1">Settlement Date</p>
                  <p-calendar
                    name="dateOffer"
                    [firstDayOfWeek]="1"
                    [ngClass]="{ invalidCalendarField: !manualHistory.date && errorMessage }"
                    [monthNavigator]="true"
                    [yearNavigator]="true"
                    yearRange="1900:2050"
                    dateFormat="dd/mm/yy"
                    class="_input"
                    [(ngModel)]="manualHistory.date"
                    placeholder="DD-MM-YY"
                    [readonlyInput]="true"
                    appendTo="body"
                    panelStyleClass="cal-overlay-top"
                    (onSelect)="selectDate()">
                  </p-calendar>
                </div>
              </div>
              <div class="col-md-12 col-lg-6 col-sm-12">
                <div class="form-group mb-0 position-relative">
                  <p class="f-12 mb-1">Purchase Price</p>
                  <app-price-input
                    [field_value]="manualHistory.price"
                    [isRequire]="!manualHistory.price && errorMessage ? true : false"
                    (onUpdate)="updatePrice($event)">
                  </app-price-input>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-lg-6 col-sm-12 pr-0">
                <div class="form-group mb-2">
                  <p class="f-12 mb-1">Agent</p>
                  <input type="text" class="_input" [(ngModel)]="manualHistory.agent" class="mt-1" />
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-2 mb-2">
              <button class="_cancel-btn mr-2" (click)="cancelTransaction()">Cancel</button>
              <button class="_outline-btn" [class.disabled]="is_disable_history" *ngIf="isEdit == false; else elsePart" (click)="saveHistory()">
                {{ is_disable_history ? 'Saving' : 'Save' }}
              </button>
              <ng-template #elsePart>
                <button class="_outline-btn" [class.disabled]="is_disable_history" (click)="updateSaveHistory()">
                  {{ is_disable_history ? 'Saving' : 'Save' }}
                </button>
              </ng-template>
            </div>
          </ng-container>
          <ng-container *ngIf="isManual">
            <div class="row">
              <div class="col-md-6 mt-2 width-100 pr-0 owner" *ngIf="showBuyer">
                <label class="f-12 mb-1">Owner</label>
                <re-multiselect
                  [module]="'contacts'"
                  [truncate]="13"
                  [selected_ids]="contactBuyer"
                  (onUpdate)="onUpdateMSelect($event, 'contactBuyer')"
                  [placeholder]="'Select Owner'"
                  [isCreateNew]="false"
                  [isMultiple]="false"
                  [isEmail]="true"
                  [style]="{ width: '100%' }">
                </re-multiselect>
              </div>
              <div class="col-md-6 mt-2 width-100 pr-0 owner" *ngIf="showSeller">
                <label class="f-12 mb-1">Owner</label>
                <re-multiselect
                  [module]="'contacts'"
                  [truncate]="13"
                  [selected_ids]="contactSeller"
                  (onUpdate)="onUpdateMSelect($event, 'contactSeller')"
                  [placeholder]="'Select Owner'"
                  [isCreateNew]="false"
                  [isMultiple]="false"
                  [isEmail]="true"
                  [style]="{ width: '100%' }">
                </re-multiselect>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-2 mb-2">
              <button class="_cancel-btn mr-2" (click)="cancelTransaction()">Cancel</button>
              <button class="_outline-btn" (click)="saveContactHistory()">Save</button>
            </div>
          </ng-container>
          <ng-container *ngIf="isLatestManual">
            <ng-container *ngIf="getManualHistory?.length > 0">
              <div class="mt-4">
                <ng-container *ngFor="let manual of getManualHistory">
                  <ng-container *ngIf="manual?.is_latest === true">
                    <ng-container *ngIf="!manual?.buyer?.length; else buyerName">
                      <div class="d-flex align-items-baseline justify-content-between">
                        <p class="contact-status f-14 _fw-600">Owner/s</p>
                        <button
                          id="toggle-overlay"
                          *ngIf="!manualGenerateHistory"
                          class="_view-btn f-12 h-auto ml-3 p-2"
                          (click)="updateHistory(manual)">
                          <img [src]="common_images?.pencil_icon" class="pencil-cross" width="12" />
                        </button>
                      </div>
                      <div class="d-flex align-items-center">
                        <ng-container *ngFor="let con of manual?.seller; let last = last">
                          <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                            {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                          </p>
                        </ng-container>
                      </div>
                    </ng-container>
                    <ng-template #buyerName>
                      <div class="d-flex align-items-baseline justify-content-between">
                        <p class="contact-status f-14 _fw-600">Owner/s</p>
                        <button
                          id="toggle-overlay"
                          *ngIf="!manualGenerateHistory"
                          class="_view-btn f-12 h-auto ml-3 p-2"
                          (click)="updateHistory(manual)">
                          <img [src]="common_images?.pencil_icon" class="pencil-cross" width="12" />
                        </button>
                      </div>
                      <div class="d-flex align-items-center">
                        <ng-container *ngFor="let con of manual?.buyer; let last = last">
                          <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                            {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                          </p>
                        </ng-container>
                      </div>
                    </ng-template>
                    <ng-container *ngIf="manual?.buyer?.length > 0; else preOwner">
                      <div class="mt-2">
                        <p class="contact-status f-14 _fw-600">Previous Owner/s w1</p>
                        <div class="d-flex align-items-center">
                          <ng-container *ngFor="let con of manual?.seller; let last = last">
                            <p class="cursor-pointer mt-1" (click)="openRightModal(con, 'edit_contact')">
                              {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                            </p>
                          </ng-container>
                        </div>
                      </div>
                    </ng-container>
                    <ng-template #preOwner>
                      <ng-container *ngIf="previousOwner?.length > 0">
                        <div class="mt-2">
                          <p class="contact-status f-14 _fw-600">Previous Owner/s</p>
                          <div class="d-flex align-items-center">
                            <ng-container *ngFor="let con of previousOwner; let last = last">
                              <p class="cursor-pointer mt-1" (click)="openRightModal(con, 'edit_contact')">
                                {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                              </p>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </ng-template>
                  </ng-container>
                </ng-container>
              </div>
              <div class="mt-3">
                <ng-container *ngFor="let item of getManualHistory">
                  <div class="d-flex align-items-center mb-2">
                    <div class="d-flex align-items-center">
                      <ng-container *ngIf="item?.property_status; else pro_status">
                        <div
                          class="status-color cursor-pointer"
                          [ngStyle]="{ 'background-color': item?.background_color }"
                          (click)="openListingDetailModal(item)"></div>
                        <p class="status cursor-pointer f-12" (click)="openListingDetailModal(item)">
                          {{ item?.property_status }}
                        </p>
                      </ng-container>
                      <ng-template #pro_status>
                        <div class="status-manual-color cursor-pointer" (click)="openManualCurrentDetail(item)"></div>
                        <p class="status cursor-pointer f-12" (click)="openManualCurrentDetail(item)">Settled</p>
                      </ng-template>
                    </div>
                    <div *ngIf="item?.property_status; else date" (click)="openListingDetailModal(item)" style="width: 135px !important">
                      <p class="f-12 text-left w-80px">{{ item?.created_at | date: 'd MMM y' }}</p>
                    </div>
                    <ng-template #date>
                      <p class="f-12 text-left w-80px" (click)="openManualCurrentDetail(item)" style="width: 135px !important">
                        {{ item?.date | date: 'd MMM y' }}
                      </p>
                    </ng-template>
                    <ng-container *ngIf="getManualHistory?.length > 0">
                      <ng-container *ngFor="let manual of getManualHistory">
                        <ng-container *ngIf="manual?.is_latest === true">
                          <ng-container *ngIf="!manual?.buyer?.length; else buyerName">
                            <p class="mr-2">Purchased By:</p>
                            <div class="d-flex align-items-center">
                              <ng-container *ngFor="let con of manual?.seller; let last = last">
                                <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                                  {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                                </p>
                              </ng-container>
                            </div>
                          </ng-container>
                          <ng-template #buyerName>
                            <div class="d-flex align-items-center">
                              <p class="mr-2">Purchased By:</p>
                              <ng-container *ngFor="let con of manual?.buyer; let last = last">
                                <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                                  {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                                </p>
                              </ng-container>
                            </div>
                          </ng-template>
                        </ng-container>
                      </ng-container>
                    </ng-container>
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="isLatestListing">
            <div *ngIf="listingPropertyHistory?.length > 0">
              <ng-container *ngFor="let listingStatus of listingPropertyHistory">
                <ng-container
                  *ngIf="
                    listingStatus.is_latest === true &&
                    listingStatus.property_status !== 'Sold' &&
                    listingStatus.property_status !== 'Leased' &&
                    listingStatus.property_status !== 'Withdraw' &&
                    listingStatus.property_status !== 'Withdrawn'
                  ">
                  <div
                    class="listing-search-history cursor-pointer"
                    (click)="is_date_show ? '' : openRightModal(listingStatus?._id, 'edit_listing_property')">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                      <p class="f-12">{{ listingStatus?.property_status }}</p>
                      <p class="f-12" *ngIf="listingStatus?.value">
                        {{ listingStatus?.value | currency: 'USD' : 'symbol' : '1.0-0' }}
                      </p>
                    </div>
                    <div class="d-flex align-items-center justify-content-between">
                      <p class="seller-name">
                        {{ listingStatus?.agent?.full_name }}
                      </p>
                      <p class="f-12" *ngIf="is_date_show == false" (click)="allowChangeDate(); $event.stopPropagation()">
                        {{ moment.utc(listingStatus?.created_at).format('DD MMM YYYY') }}
                      </p>
                      <ng-container *ngIf="is_date_show == true">
                        <p-calendar
                          [firstDayOfWeek]="1"
                          [(ngModel)]="change_date"
                          [ngModelOptions]="{ standalone: true }"
                          [maxDate]="minDated"
                          dateFormat="dd/mm/yy"
                          class="_input"
                          placeholder="Date"
                          (onSelect)="changeDate(listingStatus?._id); $event.stopPropagation()"
                          class="w-50"
                          [readonlyInput]="true">
                        </p-calendar>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div class="mt-4">
              <ng-container *ngIf="contactLists?.length > 0">
                <div class="mb-2">
                  <p class="contact-status mb-2 f-14 _fw-600">Owner/s</p>
                  <div class="d-flex align-items-center">
                    <ng-container *ngFor="let con of contactLists; let last = last">
                      <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                        {{ con?.contacts?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
              <ng-container *ngIf="contactLists?.length > 0">
                <ng-container *ngFor="let listingStatus of listingPropertyHistory">
                  <ng-container *ngIf="listingStatus.is_latest === true">
                    <p class="contact-status f-14 mb-2 _fw-600">Previous Owner/s</p>

                    <div class="d-flex align-items-center">
                      <ng-container *ngFor="let con of getPreviousOwners(listingStatus.listing_contacts); let last = last">
                        <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                          {{ con?.contacts?.full_name }}
                          <span *ngIf="!last">,&nbsp;</span>
                        </p>
                      </ng-container>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="!contactLists?.length">
                <ng-container *ngFor="let listingStatus of listingPropertyHistory">
                  <ng-container *ngIf="listingStatus.is_latest === true && listingStatus?.listing_contacts?.length > 0">
                    <p class="contact-status f-14 _fw-600">Owner/s</p>
                    <ng-container *ngFor="let con of listingStatus?.listing_contacts; let last = last">
                      <ng-container *ngIf="con.type?.includes('Owner') || con.type?.includes('Seller')">
                        <div class="d-flex align-items-center justify-content-between mt-1">
                          <p class="cursor-pointer" (click)="openRightModal(con, 'edit_contact')">
                            {{ con?.contacts?.full_name }}
                          </p>
                          <button id="toggle-overlay" class="_view-btn f-12 h-auto p-2" (click)="updateContactHistory(con)">
                            <img [src]="common_images?.pencil_icon" class="pencil-cross" width="12" />
                          </button>
                        </div>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="previousOwner?.length > 0 && !contactLists?.length">
                <div class="mt-2">
                  <p class="contact-status f-14 _fw-600">Previous Owner/s</p>
                  <div class="d-flex align-items-center">
                    <ng-container *ngFor="let con of previousOwner; let last = last">
                      <p class="cursor-pointer mt-1" (click)="openRightModal(con, 'edit_contact')">
                        {{ con?.full_name }}<span *ngIf="!last">,&nbsp;</span>
                      </p>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
            <div class="mt-3">
              <div *ngFor="let status of allStatus">
                <div class="d-flex align-items-center" *ngIf="status?.is_hide != true">
                  <div class="d-flex align-items-center">
                    <ng-container *ngIf="status?.property_status; else pro_status">
                      <div
                        class="status-color cursor-pointer"
                        [ngStyle]="{ 'background-color': status?.background_color }"
                        (click)="openListingDetailModal(status)"></div>
                      <p class="status cursor-pointer f-12" (click)="openListingDetailModal(status)">
                        {{ status?.property_status }}
                      </p>
                    </ng-container>
                    <ng-template #pro_status>
                      <div class="status-manual-color cursor-pointer" (click)="openManualCurrentDetail(status)"></div>
                      <p class="cursor-pointer f-12 ml-1" (click)="openManualCurrentDetail(status)" style="min-width: 120px">Settled</p>
                    </ng-template>
                  </div>
                  <div *ngIf="status?.property_status; else date" (click)="openListingDetailModal(status)" style="width: 135px">
                    <ng-container *ngIf="status?.contracts[0]?.settlement; else settledDate">
                      <p class="f-12 text-left w-80px">
                        {{ status?.contracts[0]?.settlement | date: 'd MMM y' }}
                      </p>
                    </ng-container>
                    <ng-template #settledDate>
                      <ng-container
                        *ngIf="
                          status?.property_status?.toLowerCase() == 'withdrawn' || status?.property_status?.toLowerCase() == 'withdraw';
                          else createAt
                        ">
                        <p class="f-12 text-left w-80px">{{ status?.withdrawn_date | date: 'd MMM y' }}</p>
                      </ng-container>
                      <ng-template #createAt>
                        <ng-container>
                          <p class="f-12 text-left w-80px">{{ status?.created_at | date: 'd MMM y' }}</p>
                        </ng-container>
                      </ng-template>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="contactLists?.length > 0; else noContactList">
                    <div class="d-flex align-items-center">
                      <p class="mr-2">Purchased By:</p>
                      <ng-container *ngFor="let con of contactLists; let last = last">
                        <p>{{ con?.contacts?.full_name }}<span *ngIf="!last">,&nbsp;</span></p>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #noContactList>
                    <ng-container *ngIf="status?.buyer?.length > 0">
                      <div class="d-flex align-items-center">
                        <p class="mr-2">Purchased By:</p>
                        <ng-container *ngFor="let buyer of status?.buyer; let last = last">
                          <p>{{ buyer?.full_name }}<span *ngIf="!last">,&nbsp;</span></p>
                        </ng-container>
                      </div>
                    </ng-container>
                  </ng-template>
                  <ng-template #date>
                    <div (click)="openManualCurrentDetail(status)" style="width: 135px">
                      <p class="f-12 text-left w-80px">{{ status?.date | date: 'd MMM y' }}</p>
                    </div>
                  </ng-template>
                </div>
              </div>
            </div>
            <div *ngIf="!getManualHistory && !listingPropertyHistory?.length && !allStatus?.length">
              <p class="f-12">No Listing History</p>
            </div>
          </ng-container>
        </div>
        <div
          id="PropertyHistory"
          role="tabpanel"
          aria-labelledby="pills-PropertyHistory-tab"
          tabindex="0"
          class="tab-pane fade {{ activeIndexRight === 1 && 'show active' }}">
          <ng-container *ngIf="activeIndexRight === 1">
            <app-remmi-history [module]="'Property'" [record_id]="property_id || insertedPropertyId"></app-remmi-history>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<app-confirmation-dialog #listingHistoriesDialog viewonly="true" [title]="'Full Listing History'" [propertyHistory]="true">
  <div class="ModalGetLink" *ngFor="let item of allStatus">
    <div class="ModalGetLink-header p-effect cursor-pointer confirm-dailog" (click)="openRightModal(item?._id, 'edit_listing_property')">
      <div class="d-flex align-items-center py-2 bordered-bottom">
        <ng-container *ngIf="item?.property_status; else pro_status">
          <div class="status-color mr-2" [ngStyle]="{ 'background-color': item?.background_color }"></div>
          <p>
            <b>{{ item?.property_status }}</b>
          </p>
        </ng-container>
        <ng-template #pro_status>
          <div class="status-manual-color mr-2"></div>
          <p><b>Settled</b></p>
        </ng-template>
      </div>
      <div>
        <div class="w-100 d-flex align-items-center justify-content-between py-2 bordered-bottom">
          <ng-container *ngIf="item?.agent?.full_name; else agentName">
            <p>Agent:</p>
            <span class="text-captilize">{{ item?.agent?.full_name }}</span>
          </ng-container>
          <ng-template #agentName>
            <p>Agent:</p>
            <span class="text-captilize">{{ item?.agent }}</span>
          </ng-template>
        </div>
        <div class="w-100 d-flex align-items-center justify-content-between py-2 bordered-bottom">
          <ng-container *ngIf="item?.contracts?.length > 0 && item?.contracts[0]?.settlement; else createdDate">
            <p class="text-captilize">Date:</p>
            <span>{{ item?.contracts[0]?.settlement | date: 'd MMM y' }}</span>
          </ng-container>
          <ng-template #createdDate>
            <p class="text-captilize" *ngIf="item?.is_manual_history || item?.created_at">Date:</p>
            <span>
              {{ item?.is_manual_history ? (item?.date | date: 'd MMM y') : (item?.created_at | date: 'd MMM y') }}
            </span>
          </ng-template>
        </div>
        <div class="w-100 d-flex align-items-center justify-content-between py-2">
          <ng-container *ngIf="item?.value; else priceValue">
            <p>Price:</p>
            <span>{{ item?.value | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
          </ng-container>
          <ng-template #priceValue>
            <p>Price:</p>
            <span>{{ item?.price | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="ModalGetLink hoverEffect" *ngIf="!allStatus?.length">
    <div class="ModalGetLink-header p-effect">
      <p>No History</p>
    </div>
  </div>
</app-confirmation-dialog>

<app-confirmation-dialog #manualDetailDialog viewonly="true" [title]="'Full Listing History'" [propertyHistory]="true">
  <ng-container *ngIf="getManualHistory?.length > 0">
    <div class="ModalGetLink" *ngFor="let item of getManualHistory">
      <div class="ModalGetLink-header p-2 cursor-pointer model-box">
        <div class="d-flex align-items-center">
          <div class="status-manual-color mr-2" [ngStyle]="{ 'background-color': item?.background_color }"></div>
          <p><b>Settled</b></p>
        </div>
        <div class="d-flex align-items-center pt-2">
          <div class="w-100 d-flex align-items-center justify-content-between">
            <span class="text-captilize">Date: <span></span> {{ item?.date | date: 'd MMM y' }}</span>
          </div>
          <div class="w-100 d-flex align-items-center justify-content-between">
            <span class="text-captilize">Price: <span></span> {{ item?.price | currency: 'USD' : 'symbol' : '1.0-0' }}</span>
          </div>
          <div class="w-100 d-flex align-items-center justify-content-between">
            <ng-container *ngIf="item?.agent?.full_name; else agentName">
              <span class="text-captilize">Agent: <span></span> {{ item?.agent?.full_name }}</span>
            </ng-container>
            <ng-template #agentName>
              <span class="text-captilize">Agent: <span></span> {{ item?.agent }}</span>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="ModalGetLink hoverEffect" *ngIf="!getManualHistory?.length">
    <div class="ModalGetLink-header p-effect">
      <p>No History</p>
    </div>
  </div>
</app-confirmation-dialog>

<app-confirmation-dialog
  #listingDetailDialog
  [propertyHistory]="true"
  viewonly="true"
  [title]="
    'Listing History' +
    listingGlobalItem?.property_status +
    ' ' +
    (listingGlobalItem?.contracts[0]?.settlement || listingGlobalItem?.created_at | date: 'd MMM y')
  ">
  <ng-container *ngIf="listingGlobalItem">
    <div class="ModalGetLink">
      <div class="ModalGetLink-header p-effect cursor-pointer" (click)="openRightModal(listingGlobalItem?._id, 'edit_listing_property')">
        <div class="d-flex align-items-start">
          <div
            *ngIf="
              listingGlobalItem?.property_images?.length > 0 && listingGlobalItem?.property_images[property_img?.length - 1]?.thumbPath;
              else elsePart
            ">
            <img
              src="{{ S3Path + listingGlobalItem?.property_images[listingGlobalItem?.property_images.length - 1]?.thumbPath }}"
              class="project-dp" />
          </div>
          <ng-template #elsePart>
            <div>
              <img [src]="common_images?.image_not_found" class="no-images" />
            </div>
          </ng-template>
          <div class="w-100 ml-3 pl-2">
            <p class="f-12 _fw-700">{{ editProperty.controls['property_address']?.value }}</p>
            <br />
            <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
              <p>{{ listingGlobalItem?.property_status }}</p>
              <ng-container *ngIf="listingGlobalItem?.contracts[0]?.settlement; else settledDate">
                <p>{{ listingGlobalItem?.contracts[0]?.settlement | date: 'd MMM y' }}</p>
              </ng-container>
              <ng-template #settledDate>
                <p>{{ listingGlobalItem?.created_at | date: 'd MMM y' }}</p>
              </ng-template>
            </div>
            <ng-container *ngIf="listingGlobalItem?.contracts?.length > 0; else settledPrice">
              <div class="d-flex mt-2 align-items-center justify-content-between py-2 bordered-bottom">
                <p>Price:</p>
                <p>{{ listingGlobalItem?.contracts[0]?.contractPrice }}</p>
              </div>
            </ng-container>
            <ng-template #settledPrice>
              <div class="d-flex mt-2 align-items-center justify-content-between py-2 bordered-bottom">
                <p>Price:</p>
                <p>{{ listingGlobalItem?.value | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
              </div>
            </ng-template>
            <div>
              <ng-container *ngIf="globalItemContact?.length > 0">
                <ng-container *ngFor="let items of globalItemContact">
                  <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
                    <p>Buyer:</p>
                    <p>{{ items?.contacts?.full_name }}</p>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngFor="let items of listingGlobalItem.listing_contacts">
                <ng-container *ngIf="!globalItemContact?.length">
                  <ng-container *ngFor="let tags of items.type">
                    <ng-container *ngIf="tags === 'Buyer'">
                      <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
                        <p>Buyer:</p>
                        <p>{{ items?.contacts?.full_name }}</p>
                      </div>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-container *ngFor="let tags of items.type">
                  <ng-container *ngIf="tags === 'Seller'">
                    <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
                      <p>Seller:</p>
                      <p>{{ items?.contacts?.full_name }}</p>
                    </div>
                  </ng-container>
                </ng-container>
              </ng-container>
            </div>
            <div class="d-flex mt-2 align-items-center justify-content-between py-2 bordered-bottom">
              <p>Agent:</p>
              <p>{{ listingGlobalItem?.agent?.full_name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="ModalGetLink hoverEffect" *ngIf="!listingGlobalItem">
    <div class="ModalGetLink-header p-effect">
      <p>No History</p>
    </div>
  </div>
</app-confirmation-dialog>

<app-confirmation-dialog
  #manualCurrentDetailDialog
  [propertyHistory]="true"
  viewonly="true"
  [title]="'Listing History: ' + 'Settled' + ' ' + (manualGlobalItem?.date | date: 'd MMM y')">
  <ng-container *ngIf="manualGlobalItem">
    <div class="ModalGetLink-header p-effect cursor-pointer">
      <div class="d-flex align-items-start">
        <div
          *ngIf="
            manualGlobalItem?.property_images?.length > 0 &&
              manualGlobalItem?.property_images[manualGlobalItem?.property_images?.length - 1]?.thumbPath;
            else elsePart
          ">
          <img src="{{ S3Path + manualGlobalItem?.property_images[manualGlobalItem?.property_images?.length - 1]?.thumbPath }}" class="project-dp" />
        </div>
        <ng-template #elsePart>
          <div>
            <img [src]="common_images?.image_not_found" class="no-images" />
          </div>
        </ng-template>
        <div class="w-100 ml-3 pl-2">
          <p class="f-12 _fw-700">{{ editProperty.controls['property_address'].value }}</p>
          <br />
          <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
            <p>Settled:</p>
            <p>{{ manualGlobalItem?.date | date: 'd MMM y' }}</p>
          </div>
          <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
            <p>Price:</p>
            <p>{{ manualGlobalItem?.price | currency: 'USD' : 'symbol' : '1.0-0' }}</p>
          </div>
          <div>
            <ng-container *ngIf="manualGlobalItem?.buyer?.length <= 0; else sellerName">
              <ng-container *ngFor="let items of manualGlobalItem?.seller">
                <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
                  <p>Owner:</p>
                  <p>{{ items?.full_name }}</p>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #sellerName>
              <ng-container *ngFor="let items of manualGlobalItem?.seller">
                <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
                  <p>Seller:</p>
                  <p>{{ items?.full_name }}</p>
                </div>
              </ng-container>
            </ng-template>
          </div>
          <div>
            <ng-container *ngFor="let items of manualGlobalItem?.buyer">
              <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
                <p>Buyer:</p>
                <p>{{ items?.full_name }}</p>
              </div>
            </ng-container>
          </div>
          <div>
            <div class="d-flex align-items-center justify-content-between py-2 bordered-bottom">
              <p>Agent:</p>
              <p>{{ manualGlobalItem?.agent }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <div class="ModalGetLink hoverEffect" *ngIf="!manualGlobalItem">
    <div class="ModalGetLink-header p-effect">
      <p>No History</p>
    </div>
  </div>
</app-confirmation-dialog>
